/**
 * IMPORTS
 */
import {IChatState} from 'src/aggregates/conversations/state.d';


/**
 * CODE
 */

/**
 * Chat initial state.
 */
const initialState: IChatState = {
    agents: [],
    byAgent: {},
    byCustomer: {},
    byId: {},
    connected: true,
    connecting: 0,
    conversation: {
        hasCreationError: false,
        hasError: false,
        hasFinishError: false,
        hasLoadByCustomerError: false,
        hasLoadByPeriodError: false,
        hasLoadError: false,
        hasLoadingPageError: false,
        hasMorePages: true,
        hasOnlineAgentsLoadError: false,
        hasTemplateSendError: false,
        hasTransferError: false,
        isCreating: false,
        isFetching: false,
        isFinishing: false,
        isLoading: false,
        isLoadingByCustomer: false,
        isLoadingByPeriod: false,
        isLoadingOnlineAgents: false,
        isLoadingPage: false,
        isTransferring: false,
    },
    creationFailureReason: '',
    current: null,
    currentAccount: null,
    currentChannel: 'null_null',
    currentContact: null,
    customers: {},
    errorMessage: '',
    feedbacks: [],
    finishedById: {},
    forwardingMessages: {},
    hasLoadByIdsError: false,
    history: [],
    isForwarding: false,
    isLoadingByIds: false,
    isSessionForciblyEnded: false,
    lastRedirect: null,
    metrics: {
        agents: {
            byId: {},
            hasTemplatesError: false,
            isTemplatesLoading: false,
            lastEnd: null,
            lastStart: null,
        },
        answered: {
            conversations: [],
            count: 0,
        },
        byAccount: {},
        byPeriod: {},
        byQueue: {},
        chatbot: {
            conversations: [],
            count: 0,
        },
        contacts: [],
        conversations: [],
        endDate: null,
        filters: {
            account: null,
            queue: null,
        },
        finished: {
            conversations: [],
            count: 0,
        },
        hasError: false,
        incoming: {
            conversations: [],
            count: 0,
        },
        isLoading: false,
        lastEnd: null,
        lastStart: null,
        lost: {
            conversations: [],
            count: 0,
        },
        ongoing: {
            conversations: [],
            count: 0,
        },
        outgoing: {
            conversations: [],
            count: 0,
        },
        outgoingAgent: {
            conversations: [],
            count: 0,
        },
        outgoingSystem: {
            conversations: [],
            count: 0,
        },
        quality: {
            analysisError: null,
            analyzing: false,
            byId: {},
            endDate: null,
            errorCode: null,
            filters: {
                account: null,
                agent: null,
                queue: null,
                score: null,
            },
            hasError: false,
            lastEnd: null,
            lastStart: null,
            loading: false,
            startDate: null,
        },
        realTime: {
            accounts: {},
            apps: {},
            attending: {
                conversations: {
                    hasAgentAnswer: [],
                    incoming: [],
                    outgoing: [],
                    total: [],
                },
                hasAgentAnswer: 0,
                incoming: 0,
                outgoing: 0,
                total: 0,
            },
            chatbot: {
                conversations: {
                    hasAgentAnswer: [],
                    incoming: [],
                    outgoing: [],
                    total: [],
                },
                hasAgentAnswer: 0,
                incoming: 0,
                outgoing: 0,
                total: 0,
            },
            conversations: {
                hasAgentAnswer: [],
                incoming: [],
                outgoing: [],
                total: [],
            },
            hasAgentAnswer: 0,
            hasError: false,
            incoming: 0,
            isFetching: false,
            outgoing: 0,
            queued: {
                conversations: {
                    hasAgentAnswer: [],
                    incoming: [],
                    outgoing: [],
                    total: [],
                },
                hasAgentAnswer: 0,
                incoming: 0,
                outgoing: 0,
                total: 0,
            },
            total: 0,
        },
        startDate: null,
        times: {
            attendance: {
                conversations: 0,
                time: 0,
            },
            chatbot: {
                conversations: 0,
                time: 0,
            },
            firstAnswer: {
                conversations: 0,
                time: 0,
            },
        },
    },
    onQueue: 0,
    ongoing: [],
    page: 1,
    searchTerm: '',
    started: false,
    stopped: false,
    user: {
        session: null,
    },
};


/**
 * EXPORTS
 */
export default initialState;
